import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BotaoFecharComponent } from '@components/botao-fecha/botao-fechar.component';
import { AlertaService } from './alerta.service';
import { ModalAlertaComponent } from './modal-alerta/modal-alerta.component';
import { ModalBtnsComponent } from './modal-btns/modal-btns.component';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '@shared/material.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalBotaoUnicoComponent } from './modal-botao-unico/modal-botao-unico.component';

@NgModule({
  declarations: [BotaoFecharComponent, ModalAlertaComponent, ModalBtnsComponent, ModalBotaoUnicoComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, MaterialModule, TranslateModule],
  providers: [AlertaService],
  exports: [ModalAlertaComponent, ModalBtnsComponent, BotaoFecharComponent, ModalBotaoUnicoComponent],
  entryComponents: [ModalAlertaComponent, ModalBtnsComponent, ModalBotaoUnicoComponent],
})
export class AlertaModule {}
